/**
 * Copilot Studio Client Module
 * Handles communication with Copilot Studio agent using M365 Agents SDK
 */

import { 
  CopilotStudioClient, 
  ConnectionSettings,
  CopilotStudioWebChat 
} from '@microsoft/agents-copilotstudio-client';
import { getConfig } from './config';

let copilotClient: CopilotStudioClient | null = null;

/**
 * Reset the Copilot client to force a new conversation
 */
export function resetCopilotClient(): void {
  copilotClient = null;
}

/**
 * Create connection settings for Copilot Studio
 */
function createConnectionSettings(): ConnectionSettings {
  const config = getConfig();
  return new ConnectionSettings({
    environmentId: config.copilotStudio.environmentId,
    agentIdentifier: config.copilotStudio.agentIdentifier,
  });
}

/**
 * Initialize the Copilot Studio client with the user's token
 * Always creates a new client instance for fresh conversations
 */
export function initializeCopilotClient(token: string): CopilotStudioClient {
  // Always create a new client to ensure fresh conversation
  const settings = createConnectionSettings();
  copilotClient = new CopilotStudioClient(settings, token);
  return copilotClient;
}

/**
 * Get the current Copilot Studio client instance
 */
export function getCopilotClient(): CopilotStudioClient | null {
  return copilotClient;
}

/**
 * Create a WebChat DirectLine connection for the chat UI
 */
export function createWebChatConnection(client: CopilotStudioClient, options?: { showTyping?: boolean }) {
  return CopilotStudioWebChat.createConnection(client, {
    showTyping: options?.showTyping ?? true,
  });
}

/**
 * Get the scope required for token acquisition
 */
export function getCopilotStudioScope(): string {
  const settings = createConnectionSettings();
  return CopilotStudioClient.scopeFromSettings(settings);
}
